'use strict';

const h = require('phy');

const shouldFade = ({ fadeNode }) => (fadeNode ? '.fade-out' : '');

const selectNotification = props => {
  const { messageText, notificationKlass, touchRequest } = props;
  return h(
    touchRequest
      ? `.notification${notificationKlass}${shouldFade(props)}`
      : `${notificationKlass}`,
    { role: 'alert' },
    messageText
  );
};

module.exports = selectNotification;
